import { render, staticRenderFns } from "./UnitOfMeasuresRegistryList.vue?vue&type=template&id=1adad634"
import script from "./UnitOfMeasuresRegistryList.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasuresRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports